/* Belle Skin, scroll reveal. Add class "belle-reveal" to any container;
   its direct children fade + slide up, staggered, when scrolled into view.
   Remove the class (or this script) to disable. Respects reduced-motion. */
(function () {
  function reveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.belle-reveal > *').forEach(function (c) { c.classList.add('brv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var shown = 0;
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.transitionDelay = (shown * 70) + 'ms';
          e.target.classList.add('brv-in');
          shown++;
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    document.querySelectorAll('.belle-reveal > *:not(.brv-in)').forEach(function (c) { io.observe(c); });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
